import PrivateRoutes from "./PrivateRouter";
import PublicRoutes from "./PublicRoutes";

const MainRouter: React.FC = () => {
    return false ? <PrivateRoutes/> : <PublicRoutes/>
}

export default MainRouter;
